import { gtmDataLayer } from "../../utils/gtm";

export const createLinkEl = ($head) => {
  const CalendlyCss = "https://assets.calendly.com/assets/external/widget.css";
  const linkEl = document.createElement("link");
  linkEl.type = "text/css";
  linkEl.rel = "stylesheet";
  linkEl.href = CalendlyCss;
  $head.append(linkEl);
};

export const calendly_view = () => gtmDataLayer("calendly_view");

export const calendly_select_date_and_time = () =>
  gtmDataLayer("calendly_select_date_and_time");

export const calendly_meeting_scheduled = () => {
  let includes = false;
  dataLayer.forEach((elem) => {
    if (elem.event === "calendly_meeting_scheduled") {
      includes = true;
    }
  });

  if (!includes) {
    gtmDataLayer("calendly_meeting_scheduled");
  }
};
